<template>
  <v-row class="flex-nowrap content-row" align="stretch" no-gutters>
    <navigation :selected="currentTab" class="sidebar"></navigation>
    <component :is="AmazonTransparencyContent" :ref="currentTab" class="flex-shrink-1 content flex-grow-1"></component>
  </v-row>
</template>

<script>

import ProductDetails from '@/components/amazon-transparency/ProductDetails.vue'
import Products from '@/components/amazon-transparency/Products'
import Transactions from '@/components/amazon-transparency/Transactions'
import Config from '@/components/amazon-transparency/Config'
import Navigation from '@/components/amazon-transparency/Navigation'

export default {
  name: 'AmazonTransparency',
  components: {
    Navigation,
    Products,
    Transactions,
    Config,
    ProductDetails
  },
  computed: {
    currentTab () {
      const tab = this.$route.name.split('amazon-transparency.')[1]
      if (tab === 'product-details' || !tab) {
        return 'products'
      }

      return tab
    },

    AmazonTransparencyContent () {
      switch (this.$route.name) {
        case 'amazon-transparency.products': return Products
        case 'amazon-transparency.transactions': return Transactions
        case 'amazon-transparency.config': return Config
        case 'amazon-transparency.product-details': return ProductDetails
      }
      return Products
    }
  },
  async created () {
    try {
      await this.$store.dispatch('setIsLoadingATPConfig', true)
      await this.$store.dispatch('loadATPConfig')
      await this.$store.dispatch('setIsLoadingATPConfig', false)
    } catch (error) {
      await this.$store.dispatch('setIsLoadingATPConfig', false)
    }
  }
}
</script>

<style>

</style>
